/**
 * Einheitliche Namens-Formatierung im Frontend.
 *
 * Fuer LISTEN / DROPDOWNS / TABELLEN / SUCH-OPTIONEN nutzen wir konsequent
 * "Nachname, Vorname" — das macht alphabetische Sortierung intuitiv und
 * beschleunigt das Finden in langen Listen.
 *
 * Profil-Header oder persoenliche Begruessungen ("Hallo, Max") nutzen
 * weiterhin "Vorname Nachname" — siehe `formatFirstLast`.
 */

/**
 * Normalisierter Schluessel "nachname|vorname" (klein) zur Dubletten-Erkennung.
 */
export const nameKey = (person) => {
  if (!person) return '';
  const last = (person.last_name || '').trim().toLowerCase();
  const first = (person.first_name || '').trim().toLowerCase();
  return `${last}|${first}`;
};

/**
 * Liefert ein Set der Namens-Schluessel, die in `people` mehrfach vorkommen.
 * Damit wird die Personalnummer nur bei Namens-Dubletten ergaenzt.
 */
export const getDuplicateNameKeys = (people = []) => {
  const counts = new Map();
  (people || []).forEach((p) => {
    const k = nameKey(p);
    if (!k || k === '|') return;
    counts.set(k, (counts.get(k) || 0) + 1);
  });
  const dups = new Set();
  counts.forEach((count, key) => {
    if (count > 1) dups.add(key);
  });
  return dups;
};

/**
 * "Nachname, Vorname" — Standard fuer Listen, Dropdowns, Tabellen.
 * Akzeptiert Mitarbeiter- oder User-Objekte mit `first_name`/`last_name`.
 *
 * Wird ein `duplicateKeys`-Set uebergeben (siehe `getDuplicateNameKeys`),
 * wird bei Namens-Dubletten die Personalnummer ergaenzt:
 * "Schaeler, Paul (12345)".
 */
export const formatLastFirst = (person, duplicateKeys = null) => {
  if (!person) return '';
  const last = (person.last_name || '').trim();
  const first = (person.first_name || '').trim();
  let base = last && first ? `${last}, ${first}` : (last || first || '');
  if (base && duplicateKeys && duplicateKeys.has(nameKey(person))) {
    const num = person.employee_number || person.personalnummer;
    if (num) base += ` (${num})`;
  }
  return base;
};

/**
 * "Vorname Nachname" — Profil-Header, Begruessungen, Avatar-Tooltips.
 */
export const formatFirstLast = (person) => {
  if (!person) return '';
  const last = (person.last_name || '').trim();
  const first = (person.first_name || '').trim();
  if (last && first) return `${first} ${last}`;
  return first || last || '';
};

/**
 * Initialen — z.B. "MM" fuer Avatare.
 */
export const formatInitials = (person) => {
  if (!person) return '';
  const f = (person.first_name || '').charAt(0);
  const l = (person.last_name || '').charAt(0);
  return `${f}${l}`.toUpperCase();
};
